module.exports = __webpack_public_path__ + "static/media/chasebg2.13c34326.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/chasebg2.png
// module id = 15
// module chunks = 0